import { render, staticRenderFns } from "./rightsList.vue?vue&type=template&id=402147ed&"
import script from "./rightsList.vue?vue&type=script&lang=js&"
export * from "./rightsList.vue?vue&type=script&lang=js&"
import style0 from "./rightsList.vue?vue&type=style&index=0&id=402147ed&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('402147ed')) {
      api.createRecord('402147ed', component.options)
    } else {
      api.reload('402147ed', component.options)
    }
    module.hot.accept("./rightsList.vue?vue&type=template&id=402147ed&", function () {
      api.rerender('402147ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rights/rightsList.vue"
export default component.exports